import { call, put, takeEvery } from 'redux-saga/effects';
import { getBikeModel } from '../../requests/get_bike_model_request';
import { getBikeModelRequestSuccess, getBikeModelRequestFailure } from '../actions/get_bike_model.actions';
import { GET_BIKE_MODEL_REQUEST } from '../constants/get_bike_model.constants';
import { message_error } from '../../../../../components/Message';

function* getBikeModelRequest({ model_id }) {
    const got_model = yield call(getBikeModel, model_id); const
        { msg } = got_model;
    if (got_model) {
        yield put(getBikeModelRequestSuccess(got_model));
    } else {
        yield put(getBikeModelRequestFailure(msg));
        message_error(msg);
    }
}

export default function* bikeModelSaga() {
    yield takeEvery(GET_BIKE_MODEL_REQUEST, getBikeModelRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/redux/sagas/get_bike_model.saga.js